<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="代码" prop="code">
                <Input type="text" v-model="searchForm.code" placeholder="请输入代码" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="标题" prop="title">
                <Input type="text" v-model="searchForm.title" placeholder="请输入标题" clearable style="width: 200px"/>
              </Form-item>
              <span v-if="drop">
                <Form-item label="是否推荐" prop="isRecommend">
                  <Select v-model="searchForm.isRecommend" style="width: 200px">
                    <Option value="">全部</Option>
                    <Option value="0">不推荐</Option>
                    <Option value="1">推荐</Option>
                  </Select>
                  <!--<Input type="text" v-model="searchForm.isRecommend" placeholder="请输入是否推荐  0 不推荐  1 推荐" clearable style="width: 200px"/>-->
                </Form-item>
                <Form-item label="可申请次数" prop="oneTimeOnly">
                  <!--<Input type="text" v-model="searchForm.oneTimeOnly" placeholder="请输入是否此类型业务只能申请一次。  0 不是 1 是 " clearable style="width: 200px"/>-->
                  <Select v-model="searchForm.oneTimeOnly" style="width: 200px">
                    <Option value="-1">全部</Option>
                    <Option value="0">多次</Option>
                    <Option value="1">一次</Option>
                  </Select>
                </Form-item>
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
        <FormItem label="id" prop="id" hidden>
          <Input v-model="form.id" style="width:100%"/>
        </FormItem>
        <FormItem label="各端上架控制" prop="status" :hidden="!form.id">
          <Checkbox v-model="form.status1">pc</Checkbox>
          <Checkbox v-model="form.status2">android</Checkbox>
          <Checkbox v-model="form.status4">ios</Checkbox>
          <Checkbox v-model="form.status8">微信小程序</Checkbox>
          <Checkbox v-model="form.status16">支付宝小程序</Checkbox>
          <Checkbox v-model="form.status32">qq小程序</Checkbox>
          <Checkbox v-model="form.status64">百度小程序</Checkbox>
          <Checkbox v-model="form.status128">头条小程序</Checkbox>
          <Checkbox v-model="form.status256">H5移动端</Checkbox>
        </FormItem>
        <FormItem label="代码" prop="code">
          <Input v-model="form.code" style="width:100%" :readonly="form.id"/>
        </FormItem>
        <FormItem label="ios产品ID" prop="iosProductId">
          <Input v-model="form.iosProductId" style="width:100%"/>
        </FormItem>
        <FormItem label="业务类别" prop="bizType">
          <Row>
            <Col span="7">
            <Select v-model="form.bizType" @on-change="selectBizType" placeholder="请选择业务类别" style="width:100%">
              <Option v-for="(item,index) in bizTypes" :value="item.code" :key="index">{{item.name}}</Option>
            </Select>
            </Col>
            <Col span="17">
            </Col>
          </Row>
      </FormItem>
        <FormItem label="子业务类别" prop="subBizType">
          <Row>
            <Col span="7">
            <Select v-model="form.subBizType"  placeholder="请选择子业务类别" style="width:100%">
              <Option v-for="(item,index) in subBizTypes" :value="item.code" :key="index">{{item.name}}</Option>
            </Select>
            </Col>
            <Col span="17">
            </Col>
          </Row>
        </FormItem>
        <FormItem label="标题" prop="title" >
          <Input v-model="form.title" style="width:100%"/>
        </FormItem>
        <FormItem label="ios内购标题" prop="iosTitle" >
          <Input v-model="form.iosTitle" style="width:100%"/>
        </FormItem>
        <FormItem label="值(优惠后的值)" prop="value" >
          <Input v-model="form.value" style="width:100%" type="number"/>
        </FormItem>
        <FormItem label="ios内购值" prop="iosValue" >
          <Input v-model="form.iosValue" style="width:100%" type="number"/>
        </FormItem>
        <FormItem label="标示值" prop="flagValue" >
          <Input v-model="form.flagValue" style="width:100%" type="number"/>
        </FormItem>
        <FormItem label="会员账户类型" prop="accountScope" >
          <Select v-model="form.accountScope">
            <Option value="all">个人企业均可申请</Option>
            <Option value="person">个人可申请</Option>
            <Option value="enterprise">企业可申请</Option>
          </Select>
        </FormItem>
        <FormItem label="是否推荐" prop="isRecommend" >
          <Select v-model="form.isRecommend">
            <Option value="0">不推荐</Option>
            <Option value="1">推荐</Option>
          </Select>
          <!--<Input v-model="form.isRecommend" style="width:100%"/>-->
        </FormItem>
        <FormItem label="可申请次数" prop="oneTimeOnly" >
          <Select v-model="form.oneTimeOnly">
            <Option :value=0>可多次</Option>
            <Option :value=1>仅一次</Option>
          </Select>
          <!--<Input v-model="form.oneTimeOnly" style="width:100%"/>-->
        </FormItem>
        <FormItem label="排序" prop="orderNum" >
          <Input v-model="form.orderNum" style="width:100%" type="number"/>
        </FormItem>
        <!--<FormItem label="组类型" prop="groupType" >
          <Input v-model="form.groupType" style="width:100%"/>
        </FormItem>
        <FormItem label=" 附加数据" prop="attachData" >
          <Input v-model="form.attachData" style="width:100%"/>
        </FormItem>-->
        <FormItem label="备注信息" prop="remarks" >
          <Input v-model="form.remarks" style="width:100%"/>
        </FormItem>
        <FormItem label="ios内购描述" prop="iosRemarks" >
          <Input v-model="form.iosRemarks" style="width:100%"/>
        </FormItem>
        <FormItem label="时间周期" prop="period" >
          <Input v-model="form.period" style="width:100%" type="number"/>
        </FormItem>
        <FormItem label="时间周期类型" prop="periodType" >
          <Select v-model="form.periodType">
            <Option value="day">天</Option>
            <Option value="weeken">周</Option>
            <Option value="month">月</Option>
            <Option value="year">年</Option>
          </Select>
          <!--<Input v-model="form.periodType" style="width:100%"/>-->
        </FormItem>

        <!--<FormItem label="业务类型  对应register_vip_config表中的code字段。" prop="vipCode" >
          <Input v-model="form.vipCode" style="width:100%"/>
        </FormItem>-->
        <FormItem label="存证次数" prop="registerVipRights.evidenceArchiveNum" >
          <Input v-model="form.registerVipRights.evidenceArchiveNum" style="width:100%"/>
        </FormItem>
        <FormItem label="证书登记次数" prop="registerVipRights.certificateRegistrationNum" >
          <Input v-model="form.registerVipRights.certificateRegistrationNum" style="width:100%"/>
        </FormItem>
        <FormItem label="预登记次数" prop="registerVipRights.preNum" >
          <Input v-model="form.registerVipRights.preNum" style="width:100%"/>
        </FormItem>

        <FormItem label="个人预登记特惠包1年不限量" prop="registerVipRights.prePersonOneYearNum" >
          <Input v-model="form.registerVipRights.prePersonOneYearNum" style="width:100%"/>
        </FormItem>
        <FormItem label="企业预登记特惠包1年不限量" prop="registerVipRights.preEnterpriseOneYearNum" >
          <Input v-model="form.registerVipRights.preEnterpriseOneYearNum" style="width:100%"/>
        </FormItem>

        <FormItem label="预登记转登记1工下证次数" prop="registerVipRights.oneCopyrightRegisterNum" >
          <Input v-model="form.registerVipRights.oneCopyrightRegisterNum" style="width:100%"/>
        </FormItem>
        <FormItem label="预登记转登记3工下证次数" prop="registerVipRights.threeCopyrightRegisterNum" >
          <Input v-model="form.registerVipRights.threeCopyrightRegisterNum" style="width:100%"/>
        </FormItem>
        <FormItem label="预登记转登记5工下证次数" prop="registerVipRights.fiveCopyrightRegisterNum" >
          <Input v-model="form.registerVipRights.fiveCopyrightRegisterNum" style="width:100%"/>
        </FormItem>
        <FormItem label="图片监听次数" prop="registerVipRights.imageMonitorNum" >
          <Input v-model="form.registerVipRights.imageMonitorNum" style="width:100%"/>
        </FormItem>
        <FormItem label="音乐监听次数" prop="registerVipRights.musicMonitorNum" >
          <Input v-model="form.registerVipRights.musicMonitorNum" style="width:100%"/>
        </FormItem>
        <FormItem label="文本监听次数" prop="registerVipRights.textMonitorNum" >
          <Input v-model="form.registerVipRights.textMonitorNum" style="width:100%"/>
        </FormItem>
        <FormItem label="取证次数" prop="registerVipRights.forensicsNum" >
          <Input v-model="form.registerVipRights.forensicsNum" style="width:100%"/>
        </FormItem>

        <!--<FormItem label="律师咨询（电话）次数" prop="registerVipRights.lawyerConsultNum" >
          <Input v-model="form.registerVipRights.lawyerConsultNum" style="width:100%"/>
        </FormItem>
        <FormItem label="出具律师函次数" prop="registerVipRights.judicialEvidenceNum" >
          <Input v-model="form.registerVipRights.judicialEvidenceNum" style="width:100%"/>
        </FormItem>-->

        <FormItem label="问律师服务（30分钟）" prop="registerVipRights.lawyerConsult30Num" >
          <Input v-model="form.registerVipRights.lawyerConsult30Num" style="width:100%"/>
        </FormItem>
        <FormItem label="问律师服务（60分钟）" prop="registerVipRights.lawyerConsult60Num" >
          <Input v-model="form.registerVipRights.lawyerConsult60Num" style="width:100%"/>
        </FormItem>
        <FormItem label="合同审核" prop="registerVipRights.contractAuditNum" >
          <Input v-model="form.registerVipRights.contractAuditNum" style="width:100%"/>
        </FormItem>
        <FormItem label="侵权下架" prop="registerVipRights.tortShelvesNum" >
          <Input v-model="form.registerVipRights.tortShelvesNum" style="width:100%"/>
        </FormItem>
        <FormItem label="侵权判定" prop="registerVipRights.infringementDeterminationNum" >
          <Input v-model="form.registerVipRights.infringementDeterminationNum" style="width:100%"/>
        </FormItem>
        <FormItem label="出具律师函" prop="registerVipRights.lawyerLetterNum" >
          <Input v-model="form.registerVipRights.lawyerLetterNum" style="width:100%"/>
        </FormItem>
        <FormItem label="备注信息" prop="registerVipRights.remarks" >
          <Input v-model="form.registerVipRights.remarks" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {registerVipConfigSave, registerVipConfigSave2, registerVipConfigDelete, registerVipConfigPage} from '@/api/index';
export default {
  name: "RegisterVipConfig",
  components: {
  },
  data() {
    return {
      bizTypes:[
        {
          code: "20",
          name: "特惠包",
          subBizTypes: [
            {
              code: "",
              name: "无",
            }
          ]
        },
        {
          code: "15",
          name: "预登记",
          subBizTypes: [
            {
              code: "",
              name: "无",
            }
          ]
        },
        {
          code: "16",
          name: "预登记转登记办理周期",
          subBizTypes: [
            {
              code: "",
              name: "无",
            },
            {
              code: "1601",
              name: "预登记转登记1工作日下证",
            },
            {
              code: "1602",
              name: "预登记转登记3工作日下证",
            },
            {
              code: "1603",
              name: "预登记转登记5工作日下证",
            }
          ]
        },
        {
          code: "01",
          name: "存证",
          subBizTypes: [
            {
              code: "",
              name: "无",
            }
          ]
        },
        {
          code: "02",
          name: "登记",
          subBizTypes: [
            {
              code: "",
              name: "无",
            }
          ]
        },
        {
          code: "03",
          name: "取证",
          subBizTypes: [
            {
              code: "",
              name: "无",
            }
          ]
        },
        {
          code: "04",
          name: "监测",
          subBizTypes: [
            {
              code: "",
              name: "无",
            },
            {
              code: "0401",
              name: "图片监测",
            },
            {
              code: "0402",
              name: "文字监测",
            },
            {
              code: "0403",
              name: "音视频监测",
            }
          ]
        },
        {
          code: "05",
          name: "法律服务",
          subBizTypes: [
            {
              code: "",
              name: "无",
            },
            {
              code: "0501",
              name: "问律师服务（30分钟）",
            },
            {
              code: "0502",
              name: "问律师服务（60分钟）",
            },
            {
              code: "0503",
              name: "合同审核",
            },
            {
              code: "0504",
              name: "侵权下架",
            },
            {
              code: "0505",
              name: "侵权判定",
            },
            {
              code: "0506",
              name: "出具律师函",
            }
          ]
        },
        {
          code: "08",
          name: "会员开通",
          subBizTypes: [
            {
              code: "",
              name: "无",
            }
          ]
        }
      ],
      subBizTypes: [],
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        // sort: "a.create_time", // 默认排序字段
        // order: "desc", // 默认排序方式
      },
      form: { // 添加或编辑表单对象初始化数据
              id: "",
              code: "",
              title: "",
              value: "",
              flagValue: "",
              isRecommend: "",
              oneTimeOnly: "",
              orderNum: "",
              groupType: "",
              attachData: "",
              remarks: "",
              period: "",
              periodType: "",
              accountScope: "",
              registerVipRights: {
                evidenceArchiveNum: "",
                certificateRegistrationNum: '',
                imageMonitorNum: '',
                musicMonitorNum: '',
                textMonitorNum: '',
                forensicsNum: '',
                /*lawyerConsultNum: '',
                judicialEvidenceNum: '',*/
                lawyerConsult30Num: '',
                lawyerConsult60Num: '',
                contractAuditNum: '',
                tortShelvesNum: '',
                infringementDeterminationNum: '',
                lawyerLetterNum: '',
                preNum: '',
                prePersonOneYearNum: '',
                preEnterpriseOneYearNum: '',
                oneCopyrightRegisterNum: '',
                threeCopyrightRegisterNum: '',
                fiveCopyrightRegisterNum: '',
                remarks: '',
              },
              status: ""
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "代码",
          key: "code",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "ios产品ID",
          key: "iosProductId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "标题",
          key: "title",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "ios内购标题",
          key: "iosTitle",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "值(优惠后的值)",
          key: "value",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "ios内购值",
          key: "iosValue",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "标示值",
          key: "flagValue",
          minWidth: 120,
          sortable: false,
        },
          {
              title: "允许账户类型",
              key: "accountScope",
              minWidth: 120,
              sortable: false,
              render(h, params){
                  return h('span', params.row.accountScope == 'person' ? '个人' : params.row.accountScope == 'enterprise' ? '企业' : params.row.accountScope == 'all' ? '所有' : '未知');
              }
          },

          {
          title: "是否推荐",
          key: "isRecommend",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.isRecommend == '0' ? '不推荐' : params.row.isRecommend == '1' ? '推荐' : '未知');
          }
        },
        {
          title: "是否此类型业务只能申请一次",
          key: "oneTimeOnly",
          minWidth: 120,
          sortable: false,
            render(h, params){
                return h('span', params.row.oneTimeOnly == '0' ? '多次' : params.row.oneTimeOnly == '1' ? '一次' : '未知');
            }
        },
        /*{
          title: "排序",
          key: "orderNum",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "组类型",
          key: "groupType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: " 附加数据",
          key: "attachData",
          minWidth: 120,
          sortable: false,
        },*/
        {
          title: "备注信息",
          key: "remarks",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "ios内购描述",
          key: "iosRemarks",
          minWidth: 120,
          sortable: false,
        },
          {
              title: "时间周期",
              key: "period",
              minWidth: 120,
              sortable: false,
          },
          {
              title: "时间周期类型",
              key: "periodType",
              minWidth: 120,
              sortable: false,
          },

        {
            title: "存证次数",
            key: "registerVipRights.evidenceArchiveNum",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerVipRights.evidenceArchiveNum);
            }
        },
        {
            title: "证书登记次数",
            key: "registerVipRights.certificateRegistrationNum",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerVipRights.certificateRegistrationNum);
            }
        },
        {
          title: "预登记次数",
          key: "registerVipRights.preNum",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.preNum);
          }
        },
        {
          title: "个人预登记特惠包1年不限量",
          key: "registerVipRights.prePersonOneYearNum",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.prePersonOneYearNum);
          }
        },
        {
          title: "企业预登记特惠包1年不限量",
          key: "registerVipRights.preEnterpriseOneYearNum",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.preEnterpriseOneYearNum);
          }
        },
        {
          title: "预登记转登记1工剩余次数",
          key: "registerVipRights.oneCopyrightRegisterNum",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.oneCopyrightRegisterNum);
          }
        },
        {
          title: "预登记转登记3工剩余次数",
          key: "registerVipRights.threeCopyrightRegisterNum",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.threeCopyrightRegisterNum);
          }
        },
        {
          title: "预登记转登记5工剩余次数",
          key: "registerVipRights.fiveCopyrightRegisterNum",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.fiveCopyrightRegisterNum);
          }
        },
        {
            title: "图片监听次数",
            key: "registerVipRights.imageMonitorNum",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerVipRights.imageMonitorNum);
            }
        },
        {
            title: "音乐监听次数",
            key: "registerVipRights.musicMonitorNum",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerVipRights.musicMonitorNum);
            }
        },
        {
            title: "文本监听次数",
            key: "registerVipRights.textMonitorNum",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerVipRights.textMonitorNum);
            }
        },
        {
            title: "取证次数",
            key: "registerVipRights.forensicsNum",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerVipRights.forensicsNum);
            }
        },
        /*{
            title: "律师咨询（电话）次数",
            key: "registerVipRights.lawyerConsultNum",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerVipRights.lawyerConsultNum);
            }
        },
        {
            title: "出具律师函次数",
            key: "registerVipRights.judicialEvidenceNum",
            minWidth: 120,
            sortable: false,
            render(h, params){
              return h('span', params.row.registerVipRights.judicialEvidenceNum);
            }
        },*/
        {
          title: "问律师服务（30分钟）次数",
          key: "registerVipRights.lawyerConsult30Num",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.lawyerConsult30Num);
          }
        },
        {
          title: "问律师服务（60分钟）次数",
          key: "registerVipRights.lawyerConsult60Num",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.lawyerConsult60Num);
          }
        },

        {
          title: "合同审核次数",
          key: "registerVipRights.contractAuditNum",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.contractAuditNum);
          }
        },
        {
          title: "侵权下架次数",
          key: "registerVipRights.tortShelvesNum",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.tortShelvesNum);
          }
        },
        {
          title: "侵权判定次数",
          key: "registerVipRights.infringementDeterminationNum",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.infringementDeterminationNum);
          }
        },
        {
          title: "出具律师函次数",
          key: "registerVipRights.lawyerLetterNum",
          minWidth: 120,
          sortable: false,
          render(h, params){
            return h('span', params.row.registerVipRights.lawyerLetterNum);
          }
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 200,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    icon: "md-trash"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        },
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      // this.getRequest("请求路径", this.searchForm).then(res => {
      //   this.loading = false;
      //   if (res.success) {
      //     this.data = res.result.content;
      //     this.total = res.result.totalElements;
      //   }
      // });
      // 以下为模拟数据
      //this.data = [
      //];

      // registerVipConfigPage(this.searchForm).then(res => {
      //     this.data = res.result.records;
      //     this.total = res.result.total;
      //     this.loading = false;
      // })
      this.getRequest('/registerVipConfig/findPage2', this.searchForm).then(res => {
          this.loading = false;
          if(res.code == 200){
            this.data = res.result.records;
            this.total = res.result.total;
          }
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          console.log(`this.modalType: ${this.modalType}`)
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            //registerVipConfigSave({form: JSON.stringify(this.form)})
            //registerVipConfigSave2(this.form)
            this.form.status = 511;
            this.postRequest('/registerVipConfig/save2', this.form)
            .then(res => {
              this.submitLoading = false;
              if (res.code == 200) {
                this.submitLoading = false;
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }}).catch(e => {
                  this.submitLoading = false;
                  this.$Message.success("操作失败");
                  this.getDataList();
                  this.modalVisible = false;
            })
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
          } else {
            // 编辑
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            console.log(`into modify config and form is ${JSON.stringify(this.form)}`)
            this.form.status = 0;
            if(this.form.status1){
              this.form.status += 1;
            }
            if(this.form.status2){
              this.form.status += 2;
            }
            if(this.form.status4){
              this.form.status += 4;
            }
            if(this.form.status8){
              this.form.status += 8;
            }
            if(this.form.status16){
              this.form.status += 16;
            }
            if(this.form.status32){
              this.form.status += 32;
            }
            if(this.form.status64){
              this.form.status += 64;
            }
            if(this.form.status128){
              this.form.status += 128;
            }
            if(this.form.status256){
              this.form.status += 256;
            }
            this.postRequest('/registerVipConfig/save2', this.form).then(res => {
                this.submitLoading = false;
              if (res.code == 200) {
                  this.submitLoading = false;
                  this.$Message.success("成功");
                  this.getDataList();
                  this.modalVisible = false;
              }}).catch(e => {
                  this.submitLoading = false;
                  this.$Message.success("操作失败");
                  this.getDataList();
                  this.modalVisible = false;
          })
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      delete this.form.registerVipRights.id;
      this.modalVisible = true;
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      let subBizType = data.subBizType;
      this.form = data;
      this.form.status1=this.checkStatus(1, this.form.status);
      this.form.status2=this.checkStatus(2, this.form.status);
      this.form.status4=this.checkStatus(4, this.form.status);
      this.form.status8=this.checkStatus(8, this.form.status);
      this.form.status16=this.checkStatus(16, this.form.status);
      this.form.status32=this.checkStatus(32, this.form.status);
      this.form.status64=this.checkStatus(64, this.form.status);
      this.form.status128=this.checkStatus(128, this.form.status);
      this.form.status256=this.checkStatus(256, this.form.status);
      this.selectBizType(this.form.bizType);
      console.log(`form is: ${JSON.stringify(this.form)}`)
      console.log(`form is: ` + subBizType)
      this.form.subBizType = subBizType;
      this.modalVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.name + " ?",
        loading: true,
        onOk: () => {
          // 删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + v.id).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + ids).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.clearSelectAll();
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          registerVipConfigDelete(
              // this.form
              ids, {}
          ).then(res => {
              if(res.code == 200){
                  this.$Message.success("操作成功");
                  this.$Modal.remove();
                  this.clearSelectAll();
                  this.getDataList();
              }
          }).catch(e => {
              console.error(e)
              this.$Message.success("操作失败");
              this.$Modal.remove();
              this.clearSelectAll();
              this.getDataList();
          })
        }
      });
    },
    checkStatus(status, currStatus){
      return status == (status & currStatus);
    },
    selectBizType(value){
      const _this=this;
      this.bizTypes.forEach(function (item,index) {
        if(item.code==value){
          _this.subBizTypes=item.subBizTypes;
          _this.form.subBizType=item.subBizTypes[0].code;
        }
      })
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>